export default __webpack_public_path__ + "static/media/careemnow.f14d9b71.png";